module.exports = __webpack_public_path__ + "resources/img/bg_cover_partner_v2.4d4967d49ee4c35e314ae0e33eefcfa3.png";